<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<div class="image_containerf">
<img alt="images" src="images/title.jpg"/>
</div>
<h1 class="title">T<span class="smallcaps">HE</span> B<span class="smallcaps">ATTLE</span></h1>
<p class="titlea"><span class="smallcaps">OF</span></p>
<p class="titleb">J<span class="smallcaps">ACKSON</span>,</p>
<p class="titlec">M<span class="smallcaps">ISSISSIPPI</span></p>
<p class="titled">M<span class="smallcaps">AY</span> 14, 1863</p>
<p class="author">Chris Mackowski</p>
<div class="image_containerf">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?75378e8a